import { Box } from '@mui/material';

import { summaryChipCounts } from '../fold';
import { payerStateLabel } from '../stateTokens';
import type { PayerAudience, PayerState } from '../types';

import { StateChip } from './StateChip';

export interface SummaryChipsProps {
  counts: Record<PayerState, number>;
  audience?: PayerAudience;
}

/**
 * AC-8: one summary chip per non-zero state, in severity order, count
 * first. Labels come from `STATE_TOKENS` (the same source `StateChip` uses)
 * rather than a second hand-written copy, so a copy edit can't desync them.
 */
export function SummaryChips({ counts, audience }: SummaryChipsProps) {
  const chips = summaryChipCounts(counts);
  if (chips.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {chips.map(({ state, count }) => (
        <StateChip
          key={state}
          state={state}
          label={`${count} ${payerStateLabel(state, audience)}`}
        />
      ))}
    </Box>
  );
}
